// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__15eHG","list":"BalanceDue_list__3po48","listRow":"BalanceDue_listRow__2lk1H","total":"BalanceDue_total__3j01p"};